import { QuestionStatus } from '@advanza/types/Question'
import { Button, Divider, Icon } from '@advanza/ui'
import CheckButton from 'components/CheckButton'
import FlexTable from 'components/FlexTable/FlexTable'
import AutoRow from 'components/misc/AutoRow'
import OrderButtonArrows from 'components/misc/OrderButtonArrows'
import QuestionEntity from 'components/services/QuestionEntity'
import QuestionsListWarning from 'components/services/QuestionsListWarning'
import ServiceDatePickerModal from 'components/services/ServiceDatePickerModal'
import Balloon from 'components/ui/Balloon'
import FormattedTime from 'components/ui/FormattedTime'
import QuestionsListContainer from 'containers/QuestionsListContainer'
import { getWebsiteHostnameByCountryCode } from 'misc/country'
import LoadingDotsTeam from 'misc/LoadingDotsTeam'
import React from 'react'
import style from './questionsList.module.css'

class QuestionsList extends React.Component {
    constructor(props) {
        super(props)
        this.toggleShowHiddenQuestions = this.toggleShowHiddenQuestions.bind(this)
        this.renderRows = this.renderRows.bind(this)
        this.renderCols = this.renderCols.bind(this)
        this.addQuestion = this.addQuestion.bind(this)
        this.state = {
            showHiddenQuestions: false,
        }
    }

    toggleShowHiddenQuestions(show = null) {
        this.setState({
            showHiddenQuestions: show === null ? this.state.showHiddenQuestions !== true : show,
        })
    }

    statusMap = {
        0: 'fiber_new',
        1: 'visibility',
        2: 'visibility_off',
        3: 'archived',
    }

    typeMap = {
        1: {
            name: 'checkbox',
            icon: 'check_box_outline_blank',
        },
        2: {
            name: 'radio',
            icon: 'radio_button_unchecked',
        },
        /*         3: {
            name: 'select',
            icon: 'select',
        }, */
        5: {
            name: 'text',
            icon: 'format_size',
        },
        6: {
            name: 'textarea',
            icon: 'notes',
        },
        o: {
            name: 'custom details',
            icon: 'notes',
            deprecated: true, // TRUS-3311
        },
        7: {
            name: 'number',
            icon: 'filter_2',
        },
        /*         9: {
            name: 'date',
            icon: 'date_range',
        }, */
        d: {
            name: 'day picker',
            icon: 'calendar_month',
            required: 'enable_calendar',
        },
        f: {
            name: 'file',
            icon: 'insert_drive_file',
        },
        l: {
            name: 'location',
            icon: 'place',
        },
        m: {
            name: 'month picker',
            icon: 'calendar_month',
            required: 'enable_month_picker',
        },
        s: {
            name: 'Story',
            icon: 'coronavirus',
            deprecated: true, // TRUS-1609
        },
        v: {
            name: 'moment picker',
            icon: 'calendar_month',
            required: 'enable_moment_picker',
        },
    }

    definitions = {
        id: { name: '#' },
        status: { name: 'status' },
        type: { name: 'type' },
        is_availability: { name: <Icon name="event" fontSize={17} /> },
        filterable: { name: <Icon name="star" fontSize={17} /> },
        sea_page_visibility: {
            name: (
                <Balloon content="SEA page visibility - how questions appear on SEA landing pages">
                    <Icon name="ads_click" fontSize={17} />
                </Balloon>
            ),
        },
        question: { name: 'question' },
        something: { name: 'conditions' },
        order: { name: 'order', preventRedirect: true },
    }

    getSeaPageVisibilityIcon(seaPageVisibility, filterable) {
        // Only show for non-filterable questions
        if (filterable) {
            return '-'
        }

        const iconStyle = {
            fontSize: 17,
        }

        const getTooltipContent = (value) => {
            switch (value) {
                case 0:
                    return 'Default behavior - appears in both regular and SEA forms'
                case 1:
                    return 'SEA-only - appears only on SEA landing pages'
                case 2:
                    return 'SEA-hidden - hidden on SEA landing pages'
                default:
                    return 'Default behavior'
            }
        }

        const icon = (() => {
            switch (seaPageVisibility) {
                case 0: // Default behavior
                    return <Icon name="ads_click" style={{ ...iconStyle, color: '#d3d3d3' }} />
                case 1: // SEA-only
                    return <Icon name="ads_click" style={{ ...iconStyle, color: '#4CAF50' }} />
                case 2: // SEA-hidden
                    return <Icon name="ads_click" style={{ ...iconStyle, color: '#f44336' }} />
                default:
                    return <Icon name="ads_click" style={{ ...iconStyle, color: '#d3d3d3' }} />
            }
        })()

        return <Balloon content={getTooltipContent(seaPageVisibility)}>{icon}</Balloon>
    }

    getPriceQuestionIds() {
        const { serviceEntities, service } = this.props
        const { prices = {}, options = {} } = serviceEntities

        return (
            service?.prices
                ?.map((priceId) => prices[priceId])
                .filter((price) => price.option_id && !price.deleted && !price.end_date)
                .reduce((acc, price) => {
                    const option = options[price.option_id]

                    if (option && !acc.includes(option.question_id)) {
                        acc.push(option.question_id)
                    }

                    return acc
                }, []) || []
        )
    }

    renderCols(id, priceQuestionIds) {
        const { serviceEntities } = this.props
        const { questions = {} } = serviceEntities
        const question = questions[id]
        const hasRules = question.question_rules.length > 0

        return [
            <small>#{id}</small>,
            <>
                <Icon name={this.statusMap[question.status]} />
                {priceQuestionIds.includes(id) && (
                    <>
                        {' '}
                        <Icon name="euro" />
                    </>
                )}
            </>,
            <Icon>{(this.typeMap[question.type] || {}).icon}</Icon>,
            question.is_availability && <Icon name="event" fontSize={17} />,
            question.filterable && <Icon name="star" fontSize={17} />,
            this.getSeaPageVisibilityIcon(question.sea_page_visibility, question.filterable),
            question.question,
            hasRules ? (
                <Balloon
                    content={'Question is not visible unless specific options are selected'}
                    onHover={this.highlightQuestionsSubjectToRules}
                    onLeave={this.highlightQuestionsSubjectToRules}>
                    <Icon color="orange">shuffle</Icon>
                </Balloon>
            ) : (
                '-'
            ),
            <OrderButtonArrows
                clickUp={this.changeOrder.bind(this, id, 'up')}
                clickDown={this.changeOrder.bind(this, id, 'down')}
            />,
        ]
    }

    changeOrder(questionId, upOrDown, e) {
        const { changeQuestionOrder } = this.props
        changeQuestionOrder(questionId, upOrDown)
    }

    addQuestion() {
        const { service, addQuestion } = this.props
        this.toggleShowHiddenQuestions(true)
        addQuestion(service.service_id)
        // setTimeout(() => {
        //     scrollToY(document.body.scrollHeight)
        // }, 300)
    }

    renderRows(priceQuestionIds) {
        const { serviceEntities, service, serviceIsFetching } = this.props
        const { showHiddenQuestions } = this.state
        const questionIds = (service && service.questions) || []
        return questionIds
            .map((id, i) => {
                const question = serviceEntities.questions[id]
                if (question.status !== QuestionStatus.ACTIVE && !showHiddenQuestions) {
                    return null
                }
                return {
                    id,
                    cols: this.renderCols(id, priceQuestionIds),
                    expandOnClick: true,
                    dontCloseOnClickOutside: true,
                    isLoading: question._saving || serviceIsFetching,
                    isSelected: question._isTouched,
                    expanded: question._openToggle,
                    expandable: (
                        <QuestionEntity
                            key={id}
                            typeMap={this.typeMap}
                            entityId={id}
                            index={i}
                            toggleShowHiddenQuestions={this.toggleShowHiddenQuestions}
                            {...this.props}
                        />
                    ),
                }
            })
            .filter(Boolean)
    }

    render() {
        const { serviceEntities, service } = this.props

        // check that the service is loaded with all relations (ServicesTable::findOfficeItem)
        if (!service?.prices) {
            return <LoadingDotsTeam name="pieter" />
        }

        const { questions = {} } = serviceEntities

        // as replacing a price question is a manual job,
        // we want to warn the user if there are more than 2 price questions active
        const priceQuestionIds = this.getPriceQuestionIds()

        return (
            <>
                {priceQuestionIds.length > 2 && <QuestionsListWarning />}
                {priceQuestionIds.length === 2 &&
                    questions[priceQuestionIds[0]].status === QuestionStatus.ACTIVE &&
                    questions[priceQuestionIds[1]].status === QuestionStatus.ACTIVE && (
                        <QuestionsListWarning text="Two active price questions" />
                    )}
                <AutoRow>
                    <CheckButton
                        onChange={this.toggleShowHiddenQuestions.bind(this, null)}
                        checked={this.state.showHiddenQuestions}
                        msg="Show hidden"
                    />
                    <button onClick={this.addQuestion} className="plain">
                        <Icon>add</Icon> Add question
                    </button>
                    <a
                        target="_blank"
                        href={`//${getWebsiteHostnameByCountryCode(
                            this.props.countryCode,
                        )}/search/${this.props.service.url}/`}>
                        <Button name="borderedPoppins">
                            <Icon name="open_in_new" /> View wizard
                        </Button>
                    </a>
                    <ServiceDatePickerModal
                        className={style.showHiddenFilterLink}
                        serviceId={this.props.service.service_id}
                        entityKey="show_hidden_filters"
                        heading="Display new filters until"
                        trigger={
                            <Button name="link">
                                Display new filters
                                {this.props.service.show_hidden_filters && (
                                    <>
                                        {' until '}
                                        <FormattedTime
                                            date={this.props.service.show_hidden_filters}
                                            format="dd-MM-yyyy"
                                        />
                                    </>
                                )}
                            </Button>
                        }
                    />
                </AutoRow>
                <Divider m />
                <FlexTable
                    definitions={this.definitions}
                    className={style.table}
                    rows={this.renderRows(priceQuestionIds)}
                />
            </>
        )
    }
}

export default QuestionsListContainer(QuestionsList)
